import React, { useState } from 'react';
import styled from '@emotion/styled';
import PhoneIcon from '../../svg/PhoneIcon';
import FooterSocial from './FooterSocial';
import FooterCopyright from './FooterCopyright';
import { EmotionBreakpoint } from 'dw-au-react-components';
import DownArrowIcon from '../../svg/DownArrowIcon';
import { RichTextRenderer } from '../../Components/RichTextRenderer';

const StyledFooter = styled.div`
	padding: 60px 0;
`;

const StyledFooterSocial = styled.div`
	padding: 24px 16px;
	background-color: #cf004f;

	&.adc {
		background-color: #e0644f;
	}

	&.vir {
		background-color: #512698;
	}
`;

const StyledFooterPromo = styled.div`
	padding: 28px 16px;
	background-color: #cf004f;

	&.adc {
		background-color: #e0644f;
	}

	&.vir {
		background-color: #512698;
	}

	span {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #ffffff;
	}
`;

const StyledFooterPhone = styled.div`
	h6 {
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 0.15px;
		color: #ffffff;
		font-weight: bold;

		${EmotionBreakpoint('mobile')} {
			font-size: 16px;
			line-height: 24px;
		}
	}
`;

const StyledTerms = styled.div`
	margin-bottom: 20px;

	> div:last-child {
		max-height: 0;
		overflow: hidden;
		// opacity: 0;
		// transform: translateX(-20px);
		transition: max-height 0.5s cubic-bezier(0, 1, 0, 1) 0.3s,
			transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
	}

	svg {
		transition: transform 0.3s ease-in-out 0.2s;
	}

	&.active {
		svg {
			transform: rotate(-180deg);
		}

		> div:last-child {
			max-height: 9999px;
			// transform: translateX(0);
			// opacity: 1;
			transition: max-height 0.5s ease-in-out, transform 0.3s ease-in-out 0.3s,
				opacity 0.3s ease-in-out 0.3s;
		}
	}

	p,
	a {
		font-size: 14px !important;
	}

	* {
		color: #545454;
	}
`;

function Footer({
	brandData,
	footerType,
	promoCode,
	privacyCopy,
	termsCopy,
	enablePaypal,
	showCopyright,
}) {
	// console.log(brandData);
	const [termsOpen, setTermsOpen] = useState(true);
	const [privacyOpen, setPrivacyOpen] = useState(true);

	return (
		<StyledFooter>
			<div className='mb-60'>
				{footerType === 'Social' ? (
					<StyledFooterSocial className={'footer-v2__social ' + brandData.tag}>
						<div className='container'>
							<div className='d-flex justify-content-between align-items-center flex-md-row flex-column'>
								<FooterSocial brandData={brandData} />
								<StyledFooterPhone className='phone'>
									<a
										href={'tel:' + brandData?.phoneRecr}
										target='_blank'
										rel='noreferrer'
										title={
											'Are you looking for personalised wine recommendations? Or maybe you have a wine-related question. Call our Personal Wine Advisers now on ' +
											brandData?.phoneRecr
										}
										className='align-items-center d-flex font-weight-bold justify-content-end text-decoration-none'
									>
										<PhoneIcon className='flex-shrink-0' />
										<h6 className='mb-0 text-white ml-12'>
											{brandData?.phoneRecr}
										</h6>
									</a>
								</StyledFooterPhone>
							</div>
						</div>
					</StyledFooterSocial>
				) : (
					<StyledFooterPromo className={brandData.tag}>
						<div className='container'>
							<div className='d-flex justify-content-center align-items-center'>
								<PhoneIcon className='flex-shrink-0' />
								<span className='ml-12'>
									If you&lsquo;d prefer to order by phone, please call{' '}
									<a
										className='text-white'
										href={'tel:' + brandData?.phoneRecr}
										target='_blank'
										rel='noreferrer'
									>
										<strong>{brandData?.phoneRecr}</strong>
									</a>{' '}
									and quote the code <strong>{promoCode}</strong>.
								</span>
							</div>
						</div>
					</StyledFooterPromo>
				)}
			</div>

			<div className='container'>
				{termsCopy && (
					<StyledTerms className={termsOpen ? 'active' : ''}>
						<div
							className='mb-20 d-flex justify-content-start align-items-center cursor-pointer'
							onClick={() => {
								setTermsOpen(!termsOpen);
							}}
						>
							Terms & Conditions
							<DownArrowIcon className='ml-8' />
						</div>
						<div className='mb-20'>
							<RichTextRenderer content={termsCopy} />
						</div>
					</StyledTerms>
				)}

				{privacyCopy && (
					<StyledTerms className={privacyOpen ? 'active' : ''}>
						<div
							className='mb-20 d-flex justify-content-start align-items-center cursor-pointer'
							onClick={() => {
								setPrivacyOpen(!privacyOpen);
							}}
						>
							Privacy Policy
							<DownArrowIcon className='ml-8' />
						</div>
						<div className='mb-20'>
							<RichTextRenderer content={privacyCopy} />
						</div>
					</StyledTerms>
				)}

				<FooterCopyright
					brandData={brandData}
					enablePaypal={enablePaypal}
					showCopyright={showCopyright}
				/>
			</div>
		</StyledFooter>
	);
}

export default Footer;
